import { useMemo } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core-react/tracking';

type Result = {
	trackPetitionFullEndorsementClick: (petitionId: string) => void;
	trackPetitionEndorsementsViewAllClick: (petitionId: string) => void;
	trackPetitionEndorserClick: (petitionId: string) => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();

	return useMemo(
		() => ({
			trackPetitionFullEndorsementClick: (petitionId) => {
				void track('petition_endorsements_full_endorsement_click', { petition_id: petitionId });
			},
			trackPetitionEndorsementsViewAllClick: (petitionId) => {
				void track('petition_endorsements_view_all_click', { petition_id: petitionId });
			},
			trackPetitionEndorserClick: (petitionId: string) => {
				void track('petition_endorsements_endorser_click', { petition_id: petitionId });
			},
		}),
		[track],
	);
}
